import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import CityManagement from "../CityManagement";
import StateManagment from "../StateManagement";
import DistrictManagement from "../DistrictManagement";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const SDCManagement = () => {
  const [selectedButton, setSelectedButton] = useState("state");
  const { COLORS } = useThemeMode();
  

  const buttons = [
    { id: "state", label: "State Management" },
    { id: "district", label: "District Management" },
    { id: "city", label: "City Management" },
  ];
  const handleClick = (buttonId) => {
   setSelectedButton(buttonId);
  };
  const renderComponent = () => {
    switch (selectedButton) {
      case "state":
        return <StateManagment />;
      case "district":
        return <DistrictManagement />;
      case "city":
        return <CityManagement />;
      default:
        return null;
    }
  };
  return (
    <>
       <Stack spacing={2} direction="row" fullWidth>
        {buttons.map(({ id, label }) => (
          <Button
            key={id}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: selectedButton === id ? COLORS.accent : COLORS.hoverBg,
              color: selectedButton === id ? COLORS.text : COLORS.text,
              fontWeight: 600,
              "&:hover": {
                backgroundColor: selectedButton === id ? COLORS.accent : COLORS.accent,
              },
            }}
            onClick={() => handleClick(id)}
          >
            {label}
          </Button>
        ))}
      </Stack>
      {renderComponent()}
    </>
  );
};

export default SDCManagement;
